// extracted by mini-css-extract-plugin
export var dropArea = "meal-planer-dropzone-module--drop-area--52c76";
export var dropZone = "meal-planer-dropzone-module--drop-zone--1232e";
export var dropZoneTxt = "meal-planer-dropzone-module--drop-zone-txt--dcd6d";
export var inDropArea = "meal-planer-dropzone-module--in-drop-area--1d8c8";
export var small = "meal-planer-dropzone-module--small--819f8";